import React from 'react';
import Reports from '../components/Reports';

const ReportsPage = () => {
    return <Reports />;
};

export default ReportsPage;